import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=3630199d&scoped=true&"
import script from "./role-select.vue?vue&type=script&lang=js&"
export * from "./role-select.vue?vue&type=script&lang=js&"
import style0 from "./role-select.vue?vue&type=style&index=0&id=3630199d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630199d",
  null
  
)

export default component.exports